export default __webpack_public_path__ + "static/media/btl-angelled.22e29a42.png";